import React from 'react'

const PL2 = (props) => {
    console.log(props)
    let tapBeers = props.tapMenu.sections[0].items
    let canBeers = props.canMenu.sections[0].items

    return (
        <div className="taps-can-page">
            <div className="background-image">
                <div className="col-left">
                    <div className="column pl2-taps-cans-pg-left">
                        {tapBeers.map(item => (
                            <div className="pl2-tap-item-page tap-item-print">
                                    {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                    <div className="print-item-line-two-pl2">{item.containers[0].name} • <span className="style-print-pl2"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                            </div>
                        ))}
                </div>
                </div>
                <div className="col-right">
                    <div className="column pl2-taps-cans-pg-right">
                        {canBeers.map(item => (
                            <div className="pl2-can-item-page tap-item-print">
                                    {props.filterItem(item.name)} • {props.filterBrewery(item.brewery)} • $<span className="price-tap-print">{parseInt(item.containers[0].price)}</span>
                                    <div className="print-item-line-two-can-pl2">{item.containers[0].name} • <span className="style-print-can"> {props.filterStyle(item.style)}</span> • ABV {props.refactorAbv(item.abv)}% </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PL2